module.exports = __webpack_public_path__ + "static/media/travel-guru-min.28dc667a.png";